app.factory('errorInterceptor', [ '$q', '$rootScope',
    function ($q, $rootScope) {
        return {
            responseError: function (rejection) {
                if (rejection && rejection.status && (rejection.status === 403 || rejection.status === 401)) {
                    $rootScope.$broadcast(Event.ACCESS_DENIED);
                } else if (rejection.config && rejection.config.data && rejection.config.data.suppressErrors) {
                    // pass through (angular/JS exception)
                } else if (rejection && rejection.data && rejection.data[Constant.ERROR_CODE]) {
                    $rootScope.$broadcast(Event.ERROR, new ErrorVO('T.SYSTEM.ERROR.ERROR', 'T.SYSTEM.ERROR.' + rejection.data[Constant.ERROR_CODE]));
                } else {
                    $rootScope.$broadcast(Event.INTERNAL_ERROR, rejection);
                    //$rootScope.$broadcast(Event.NOTIFICATION, new NotificationVO(Enum.NOTIFICATION_TYPE.ERROR, 'T.SYSTEM.NOTIFICATION.OPERATION_FAILED'));
                }

                return $q.reject(rejection);
            }
        }
    }
]);